import { LazySwiperWhenVisible } from '@/utils/Controllers/LazySwiperController';
import SmarteditController from '@/utils/Controllers/SmarteditController';
import _isEmpty from 'lodash/isEmpty';

const SELECTOR = '.js-del-videoSlider';

const loadController = async (video, SwiperLib) => {
  const controller = await import(
    /* webpackChunkName: "DELVideoSliderController-lib" */ '@/delonghi/Controllers/DELVideoSlider/DELVideoSliderController'
  );
  controller.default(video, SwiperLib);
};

const init = () => {
  const entries = SmarteditController.getEditorialEntries(SELECTOR);
  if (!_isEmpty(entries)) {
    LazySwiperWhenVisible(entries, async (slider, SwiperLib) => {
      loadController(slider, SwiperLib);
    });
  }
};

export default async () => {
  SmarteditController.addOnReprocessPageListener(init);
  init();
};
